export const ErrorPage = ()=>{
    return <div>ERROR PAGE</div>
}